<template>
  <BModal
    id="modal-change-card-name"
    ref="modal-change-card-name"
    no-stacking
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
  >
    <ValidationObserver #default="{ invalid }">
      <BRow class="justify-center my-1 flex flex-column gap-4">
        <BCol class="flex justify-center">
          <img
            src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
            alt="Komerce"
            width="100"
          >
        </BCol>
        <BCol class="d-flex justify-content-center text-black font-semibold text-xl">
          Ubah Nama Kartu
        </BCol>
        <BCol class="d-flex justify-content-center text-black font-normal text-lg text-center">
          Kamu bisa mengubah nama kartu berdasarkan fungsi dan kebutuhanmu
        </BCol>
        <BCol class="justify-content-center">
          <BFormGroup>
            <template #label>
              <div class="text-black">
                Nama kartu saat ini
              </div>
            </template>
            <BFormInput
              v-model="card.name"
              disabled
            />
          </BFormGroup>
        </BCol>
        <BCol class="justify-content-center">
          <BFormGroup>
            <template #label>
              <div class="text-black">
                <strong class="text-primary">*</strong>
                <span>Nama kartu baru</span>
              </div>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Nama kartu baru"
              :rules="{required: true, min: 3, max:15}"
            >
              <BFormInput
                v-model="label"
                placeholder="Nama kartu baru"
                :state="errors.length > 0 ? false:null"
                @keydown="onInput($event)"
                @paste="onPaste($event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
      </BRow>
      <BRow class="mb-1">
        <BCol cols="6">
          <BButton
            variant="outline-primary"
            block
            @click="
              $refs['modal-change-card-name'].hide()
              label = null
            "
          >
            Batal
          </BButton>
        </BCol>
        <BCol cols="6">
          <BButton
            :disabled="invalid"
            :variant="invalid ? 'secondary' : 'primary'"
            type="submit"
            block
            @click.prevent="onUpdate"
          >
            Ubah Nama
          </BButton>
        </BCol>
      </BRow>
    </ValidationObserver>
  </BModal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, min, max,
} from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    card: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      min,
      max,
      label: null,
    }
  },
  methods: {
    onInput(event) {
      const isLetter = (event.key >= 'a' && event.key <= 'z') || (event.key >= 'A' && event.key <= 'Z')
      const isNumber = event.key >= '0' && event.key <= '9'
      const isControlKey = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Space'].includes(event.key)

      if (!(isLetter || isNumber || isControlKey || event.key === ' ')) {
        event.preventDefault()
      }
    },
    onPaste(event) {
      // Get pasted data
      const pastedText = (event.clipboardData || window.clipboardData).getData('text')
      // if pasted text is not a number or a letter
      if (!/^[a-zA-Z0-9\s]+$/.test(pastedText)) {
        event.preventDefault()
      }
    },
    onUpdate() {
      this.$bvModal.show('modal-verify-pin')
      this.$bvModal.hide('modal-change-card-name')
      this.updateInput()
    },
    updateInput() {
      this.$emit('update-input', this.label)
    },
    onReset() {
      this.label = null
    },
  },
}
</script>
